var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import styled from 'styled-components';
import { IconButton, Grid, Divider, LinearProgress, Box, Typography, useMediaQuery, useTheme, } from '@mui/material';
import { format } from 'date-fns';
import { Check as CheckIcon, Close as CloseIcon } from '@mui/icons-material';
import { useParams, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { invoice as api } from '../../../api';
import { useRequest } from '../../../hooks/requestHook';
import { actionColumn, useInvoiceItemColumns } from '../../../hooks/useColumns';
import { InfoIcon } from '../../atoms/Icons';
import LabeledGridItem from '../../atoms/LabeledGridItem';
import PageLayout from '../../atoms/PageLayout';
import MaterialTable from '../../MaterialTable';
import FullScreenDialog from '../../molecules/FullScreenDialog';
import InvoiceDownloadButton from '../../organisms/InvoiceDownloadButton';
import TransparencyInformation from '../../organisms/TransparencyInformation';
import { formatMoneyAmount } from '../../../utils/format';
import { camelize } from '../../../utils/camelize';
import ChangePaymentMethodButton from './ChangePaymentMethodButton';
import { useRoaster } from '../../../hooks/useRoaster';
import OfferListLinks from '../../molecules/OfferListLinks';
import StripePaymentLink from '../../organisms/StripePaymentLink';
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 16px 8px;\n\n  .checkbox-field {\n    display: flex;\n    align-items: center;\n  }\n\n  .payment-method {\n    button {\n      margin-left: 10px;\n    }\n  }\n"], ["\n  margin: 16px 8px;\n\n  .checkbox-field {\n    display: flex;\n    align-items: center;\n  }\n\n  .payment-method {\n    button {\n      margin-left: 10px;\n    }\n  }\n"])));
var NoteWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  white-space: pre-wrap;\n  word-break: break-all;\n"], ["\n  white-space: pre-wrap;\n  word-break: break-all;\n"])));
var LinkListWrapper = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  a {\n    display: block;\n  }\n"], ["\n  a {\n    display: block;\n  }\n"])));
var RoasterInvoiceDetailPage = function () {
    var _a = useParams().id, id = _a === void 0 ? '' : _a;
    var t = useTranslation().t;
    var _b = React.useState(true), loading = _b[0], setLoading = _b[1];
    var _c = React.useState(), invoice = _c[0], setInvoice = _c[1];
    var _d = React.useState(null), invoiceItemForTI = _d[0], setInvoiceItemForTI = _d[1];
    var getInvoice = useRequest(api.get);
    var taxName = (invoice === null || invoice === void 0 ? void 0 : invoice.roaster.country.taxName) || '';
    var invoiceItemColumns = useInvoiceItemColumns({ taxName: taxName });
    var roaster = useRoaster().roaster;
    var theme = useTheme();
    var actionButtonsAlign = useMediaQuery(theme.breakpoints.down('sm'))
        ? 'left'
        : 'right';
    var columns = React.useMemo(function () {
        if (!invoice) {
            return [];
        }
        var showTIAction = actionColumn(function (invoiceItem) {
            if (!invoiceItem.orderItem ||
                !invoiceItem.orderItem.fixedOrderPriceItem ||
                !invoiceItem.orderItem.fixedOrderPriceItem.breakdownPer1kg)
                return null;
            return (React.createElement(IconButton, { "aria-label": "Show Transparency Information", onClick: function () {
                    var _a, _b;
                    if (!((_a = invoiceItem.orderItem) === null || _a === void 0 ? void 0 : _a.fixedOrderPriceItem))
                        return;
                    setInvoiceItemForTI((_b = invoiceItem.orderItem) === null || _b === void 0 ? void 0 : _b.fixedOrderPriceItem);
                }, size: "large" },
                React.createElement(InfoIcon, null)));
        });
        if (invoice.version === 'v0') {
            return [
                showTIAction,
                invoiceItemColumns.description,
                invoiceItemColumns.weight,
                invoiceItemColumns.subTotal(invoice.currency),
            ];
        }
        var columns = [
            showTIAction,
            invoiceItemColumns.description,
            invoiceItemColumns.weight,
            invoiceItemColumns.beansAmount(invoice.currency),
            invoiceItemColumns.typicaHandlingAmount(invoice.currency),
            invoiceItemColumns.nonTaxedMiscAmount(invoice.currency),
            invoiceItemColumns.taxedMiscAmount(invoice.currency),
            invoiceItemColumns.tax(invoice.currency),
            invoiceItemColumns.subTotal(invoice.currency),
        ];
        if (invoice.roaster.country.code === 'JP') {
            columns.push(invoiceItemColumns.transferDate);
        }
        return columns;
    }, [invoiceItemColumns, invoice]);
    var title = React.useMemo(function () {
        if (!invoice)
            return '';
        var orderIds = invoice.orders.map(function (order) { return "#".concat(order.id); }).join(', ');
        return t('pages.invoice.title', { orderIds: orderIds });
    }, [t, invoice]);
    React.useEffect(function () {
        var canceled = false;
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        return [4 /*yield*/, getInvoice(id)];
                    case 1:
                        response = _a.sent();
                        if (canceled)
                            return [2 /*return*/];
                        setLoading(false);
                        if (!response)
                            return [2 /*return*/];
                        setInvoice(response);
                        return [2 /*return*/];
                }
            });
        }); })();
        return function () {
            canceled = true;
        };
    }, [id, getInvoice]);
    var billingTo = React.useMemo(function () {
        if (!invoice)
            return '';
        if (invoice.billingName == invoice.personName)
            return invoice.billingName;
        return "".concat(invoice.billingName, " ").concat(invoice.personName);
    }, [invoice]);
    var billingAddress = React.useMemo(function () {
        if (!invoice)
            return '';
        return "".concat(invoice.postalCode, " ").concat(invoice.prefecture, " ").concat(invoice.city, " ").concat(invoice.address).concat(invoice.building || '');
    }, [invoice]);
    var pageActions = React.useMemo(function () {
        if (!invoice || !roaster)
            return null;
        var showVatRCHelp = roaster.country.vatReverseChargeEnabled && !roaster.vatNumber;
        return (React.createElement(Box, { textAlign: actionButtonsAlign, my: 1 },
            React.createElement(InvoiceDownloadButton, { id: invoice.id, disabled: parseFloat(invoice.total || '0') <= 0 }),
            showVatRCHelp && (React.createElement(Typography, { variant: "subtitle2" }, t('pages.invoice.vatrcHelp')))));
    }, [t, roaster, invoice, actionButtonsAlign]);
    if (!invoice)
        return React.createElement(LinearProgress, null);
    return (React.createElement(PageLayout, { title: title, actions: pageActions, backLinkTo: "/roaster/invoices" },
        React.createElement(Container, null,
            React.createElement(Grid, { container: true, spacing: 2 },
                React.createElement(LabeledGridItem, { label: t('pages.invoice.paidStatus'), value: React.createElement(Box, { display: "flex", alignItems: "center" }, invoice.paidAt ? (React.createElement(React.Fragment, null,
                        React.createElement(CheckIcon, { style: { color: 'green' } }),
                        React.createElement(Typography, null, t('pages.invoice.paidMessage', {
                            paidDate: format(new Date(invoice.paidAt), 'yyyy-MM-dd'),
                        })))) : (React.createElement(React.Fragment, null,
                        React.createElement(CloseIcon, { style: { color: 'red' } }),
                        React.createElement(Typography, null, t('pages.invoice.unpaidMessage', {
                            expiredDate: invoice.expiredDate,
                        }))))) }),
                React.createElement(LabeledGridItem, { label: t('params.invoice.title'), value: invoice.title }),
                React.createElement(LabeledGridItem, { label: t('params.offerList.name'), value: React.createElement(OfferListLinks, { pathPrefix: "/roaster", offerLists: invoice.offerLists }) }),
                React.createElement(LabeledGridItem, { label: t('params.order.id'), value: React.createElement(LinkListWrapper, null, invoice.orders.map(function (order) { return (React.createElement(Link, { key: order.id, to: "/roaster/orders/".concat(order.id) },
                        "#",
                        order.id)); })) }),
                React.createElement(LabeledGridItem, { label: t('pages.invoice.billingTo'), value: billingTo }),
                React.createElement(LabeledGridItem, { label: t('pages.invoice.billingAddress'), value: billingAddress }),
                React.createElement(LabeledGridItem, { label: t('params.invoice.createdDate'), value: invoice.createdDate }),
                React.createElement(LabeledGridItem, { label: t('params.invoice.expiredDate'), value: invoice.expiredDate }),
                React.createElement(LabeledGridItem, { label: t('params.invoice.total'), value: formatMoneyAmount(invoice.total, invoice.currency) }),
                React.createElement(LabeledGridItem, { label: t('params.invoice.note'), value: React.createElement(NoteWrapper, null, invoice.note) }),
                React.createElement(LabeledGridItem, { label: t('params.invoice.paymentMethod'), value: React.createElement("div", { className: "payment-method" },
                        t("params.invoice.paymentMethods.".concat(camelize(invoice.paymentMethod))),
                        React.createElement(ChangePaymentMethodButton, { invoice: invoice, onChange: function (invoice) { return setInvoice(invoice); } })) }),
                invoice.paymentMethod !== 'bank_transfer' && (React.createElement(LabeledGridItem, { label: t('params.invoice.paymentUrl'), value: React.createElement(StripePaymentLink, { invoice: invoice }) })))),
        React.createElement(Divider, null),
        React.createElement(MaterialTable, { model: "invoiceItem", emptyValue: "-", isLoading: loading, columns: columns, data: invoice.items }),
        React.createElement(FullScreenDialog, { keepMounted: true, open: invoiceItemForTI !== null, onClose: function () {
                setInvoiceItemForTI(null);
            } }, invoiceItemForTI && (React.createElement(TransparencyInformation, { vatReverseChargeEnabled: Boolean(invoice.vatNumber), orderPriceItem: invoiceItemForTI })))));
};
export default RoasterInvoiceDetailPage;
var templateObject_1, templateObject_2, templateObject_3;
